import '@splidejs/react-splide/css/core';
import './src/styles/app.scss';
import './src/styles/colour-scheme.scss';

// Helper function to scroll to anchor
const scrollToAnchor = (hash: string, retries = 0) => {
  const element = document.querySelector(hash);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  } else if (retries < 10) {
    // Retry if element not found yet (content still loading)
    setTimeout(() => scrollToAnchor(hash, retries + 1), 100);
  }
};

export function shouldUpdateScroll({ routerProps: { location } }) {
  // Check if there's a hash in the URL (anchor link)
  if (location.hash) {
    // Wait for content to render, then scroll to anchor
    setTimeout(() => scrollToAnchor(location.hash), 100);
    return false;
  }
  
  // No hash - scroll to top as usual
  window.scrollTo(0, 0);
  const body = document.getElementsByTagName('body')[0];
  // Setting the scroll on body is required because scrolling to top doesn't work with
  // a height: 100% set on the body component, but we can't get rid of that because of
  // a Safari bug that's adding an empty margin to the right
  body.scrollTop = 0;
  return false;
}

// Handle anchor links on initial page load and route updates
export function onRouteUpdate({ location }) {
  if (location.hash) {
    setTimeout(() => scrollToAnchor(location.hash), 100);
  }
}
